import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import OTPInput from "otp-input-react";
import Switch from "react-switch";
export default function RiderRegister() {
  let errorsObj = { otp: "" };
  const [spinnerAccept, setSpinnerAccept] = useState(false);
  const [spinnerVerify, setSpinnerVerify] = useState(false);
  const [cityName, setCityName] = useState("");
  const [yearOfExp, setYearOfExp] = useState("");
  const [isSmoke, setIsSmoke] = useState(false);
  const [altNumber, setAltNumber] = useState("");
  const [errors, setErrors] = useState(errorsObj);
  const [OTP, setOTP] = useState("");
  const history = useHistory();
  const [riderID, setRiderID] = useState("");
  const [name, setName] = useState("");

  const [profileImage, setProfileImage] = useState(null);
  const [profileImageKey, setProfileImageKey] = useState(null);

  const [adharFront, setAdharFront] = useState(null);
  const [adharBack, setAdharBack] = useState(null);
  const [adharFrontKey, setAdharFrontKey] = useState(null);
  const [adharBackKey, setAdharBackKey] = useState(null);

  const [DlFrontBike, setDlFrontBike] = useState(null);
  const [DlBackBike, setDlBackBike] = useState(null);
  const [DlFrontBikeKey, setDlFrontBikeKey] = useState(null);
  const [DlBackBikeKey, setDlBackBikeKey] = useState(null);
  const [adhar, setAdhar] = useState("");
  const [email, setEmail] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [onboardId, setOnboardId] = useState("");
  const [stepOne, setStepOne] = useState(true);
  const [stepTwo, setStepTwo] = useState(false);
  const [RiderVehicleCategory, setRiderVehicleCategory] = useState("");
  const [transportCategory, setTransportCategory] = useState("");
  useEffect(() => {
    
  }, []);
  function onSendOtp(e) {
    e.preventDefault();
    setSpinnerVerify(true)
    let error = false;
    const errorObj = { ...errorsObj };
    if (OTP === "") {
      errorObj.otp = "OTP is Required";
      error = true;
    } else if (OTP.length != 4) {
      errorObj.otp = "Please Enter 4 Digit";
      error = true;
    } else {
      var details = {
        OTP: OTP,
        riderID: riderID,
        Reason: "Rider Registration",
      };
      axios
        .put(Baseurl.baseurl + `/rider/rider-verify-otp`, details)
        .then((response) => {
          if (response.data.status) {
            swal(" Verified successfully", response.data.message, "success", {
              button: "Done",
              timer: 3000,
            });
            setSpinnerVerify(false)
            history.push("/Rider-Applied");
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 3000,
            });
            setSpinnerVerify(false)
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    }

    setErrors(errorObj);
    if (error) {
      return;
    }
   
  }
  const onChangePicture = (e, id) => {
    //setUploadId(id);
    if (e.target.files[0] && e.target.files[0].size / 1048576 < 10) {
      if (e.target.files[0]) {
        if (id === "front") {
          setAdharFrontKey(e.target.files[0]);
        }
        if (id === "back") {
          setAdharBackKey(e.target.files[0]);
        }
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          if (id === "front") {
            setAdharFront(reader.result);
          }
          if (id === "back") {
            setAdharBack(reader.result);
          }
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 10MB", "error", {
        button: "Done",
        timer: 2000,
      });
    }
  };
  const onChangeProfileImage = (e) => {
    //setUploadId(id);
    if (e.target.files[0] && e.target.files[0].size / 1048576 < 10) {
      if (e.target.files[0]) {
        setProfileImageKey(e.target.files[0]);
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setProfileImage(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 10MB", "error", {
        button: "Done",
        timer: 2000,
      });
    }
  };
  const onChangeImageBike = (e, id) => {
    //setUploadId(id);
    if (e.target.files[0] && e.target.files[0].size / 1048576 < 10) {
      if (e.target.files[0]) {
        if (id === "front") {
          setDlFrontBikeKey(e.target.files[0]);
        }
        if (id === "back") {
          setDlBackBikeKey(e.target.files[0]);
        }
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          if (id === "front") {
            setDlFrontBike(reader.result);
          }
          if (id === "back") {
            setDlBackBike(reader.result);
          }
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 10MB", "error", {
        button: "Done",
        timer: 2000,
      });
    }
  };
  function submitRiderRegister(e) {
    e.preventDefault();
    console.log("spenner true")
    setSpinnerAccept(true)
    if(phoneNumber.length===10)
    {
      const data = new FormData();
      data.append("image", profileImageKey);
      data.append("image", adharFrontKey);
      data.append("image", adharBackKey);
     
      if (RiderVehicleCategory === "bike") {
        data.append("image", DlFrontBikeKey);
        data.append("image", DlBackBikeKey);
        data.append("ServiceType", transportCategory);
        data.append("name", "Bike");
        data.append("category", "two-wheeler");
      }
      let adharN = parseInt(adhar);
      data.append("Phone", phoneNumber);
      data.append("firstName", name); 
      data.append("email", email);
      data.append("fatherName", fatherName);
      // data.append("riderDOB", DOB);
      data.append("aadharNumber", adharN);
      data.append("city", cityName);
      data.append("riderExperienceInDriving", yearOfExp);
      data.append("altNumber", altNumber);
      data.append("riderSmokeDrink", isSmoke);
  
      var config = {
        method: "post",
        url: `${Baseurl.baseurl}/rider/register-rider`,
        data: data,
      };
      axios(config)
        .then(function (response) {
          if (response.data.status) {
            // swal("Completed", "Vehicle Added", "success", {
            //   button: "Done",
            //   timer: 2000,
            // });
           
            setRiderID(response.data.riderID)
            let data = {
              Phone: phoneNumber,
            };
            axios
              .post(Baseurl.baseurl + `/rider/register-rider-phone/${response.data.riderID}`, data)
              .then((response) => {
                if (response.data.status) {
                  swal("Sent OTP", response.data.message, "success", {
                    button: "Done",
                    timer: 1000,
                  });
                  setSpinnerAccept(false)
                  setStepTwo(true);
                  setStepOne(false);
                } else {
                  swal("Oops", response.data.message, "error", {
                    button: "Done",
                    timer: 1000,
                  });
                  setSpinnerAccept(false)
                }
              })
              .catch((err) => {
                // if (err.toString() === "Error: Network Error") {
                //   history.push("/offline");
                // } else {
                //   history.push("/400");
                // }
              });
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 2000,
            });
            setSpinnerAccept(false)
          }
        })
        .catch((err) => {
          // if (err.toString() === "Error: Network Error") {
          //   history.push("/offline");
          // } else {
          //   history.push("/400");
          // }
        });
    }else
    {
      swal("Oops","Phone Number Should be 10 digits", "error", {
        button: "Done",
        timer: 2000,
      });
      setSpinnerAccept(false)
    }
    
  }
  return (
    <Card
      style={{
        color: "white",
        background:
          "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
      }}
    >
      <Card.Header>
        <Card.Title className="text-white">Register Rider</Card.Title>
        <Card.Title className="text-primary">
          {stepOne ? "Step1" : "Step2"}
        </Card.Title>
      </Card.Header>
      <Card.Body>
        {stepOne && (
          <form
            onSubmit={(e) => {
              submitRiderRegister(e);
            }}
          >
            <div className="row">
              <div className="mt-2 col-sm-3">
                <label>Phone Number</label>
              </div>
              <div className="col-sm-3">
                <input
                  required
                  type="phone"
                  className="form-control"
                  id="val-username"
                  name="val-username"
                  value={phoneNumber}
                  maxLength={10}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value);
                  }}
                  placeholder="Enter Number"
                />
              </div>
              <div className="mt-2 col-sm-3">
                <label>Email (Optional)</label>
              </div>
              <div className="col-sm-3">
                <input
                  type="text"
                  className="form-control"
                  id="val-username"
                  name="val-username"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  placeholder="Enter Email"
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="mt-2 col-sm-3">
                <label>Name (As Per PAN)</label>
              </div>
              <div className="col-sm-3">
                <input
                  required
                  type="text"
                  className="form-control"
                  id="val-username"
                  name="val-username"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  placeholder="Enter Name"
                />
              </div>
              <div className="mt-2 col-sm-3">
                <label>Father Name</label>
              </div>
              <div className="col-sm-3">
                <input
                  required
                  type="text"
                  className="form-control"
                  id="val-username"
                  name="val-username"
                  value={fatherName}
                  onChange={(e) => {
                    setFatherName(e.target.value);
                  }}
                  placeholder="Enter father name"
                />
              </div>
            </div>
            
            <div className="row mt-4">
                           <label className="col-sm-3 mt-1">
                             City Name <span className="text-danger">*</span>
                           </label>
                           <div className="col-sm-3">
                             <input
                             required
                               type="text"
                               className="form-control"
                               defaultValue={cityName}
                               onChange={(event) => {
                                 setCityName(event.target.value);
                               }}
                               placeholder="Enter CityName"
                             />
                           </div>
                           <label className="col-sm-3 mt-1">
                             Alternate Number{" "}
                             <span className="text-danger">*</span>
                           </label>
                           <div className="col-sm-3">
                             <input
                             required
                               type="text"
                               className="form-control"
                               defaultValue={altNumber}
                               maxLength={10}
                               onChange={(event) => {
                                 setAltNumber(event.target.value);
                               }}
                               placeholder="Enter Alternate number"
                             />
                           </div>
                         </div>
                         <div className="row mt-4">
                           <label className="col-sm-3 mt-1">
                             Year of Expirience in driving{" "}
                             <span className="text-danger">*</span>
                           </label>
                           <div className="col-sm-3">
                             <input
                             required
                               type="text"
                               className="form-control"
                               defaultValue={yearOfExp}
                               maxLength={2}
                               onChange={(event) => {
                                 setYearOfExp(event.target.value);
                               }}
                               placeholder="Enter year of experience"
                             />
                           </div>
                           <label className="col-sm-3 mt-1">
                             Smoke/Drink <span className="text-danger">*</span>
                           </label>
                           <div className="col-sm-3">
                             <Switch
                             
                               onColor="#135334"
                               onChange={() => {
                                 setIsSmoke(!isSmoke);
                               }}
                               checked={isSmoke}
                             />
                           </div>
                         </div>
            <div className="row mt-4">
              <div className="mt-2 col-sm-3">
                <label>Adhar Number</label>
              </div>
              <div className="col-sm-9">
                <input
                  required
                  type="text"
                  className="form-control"
                  id="val-username"
                  name="val-username"
                  value={adhar}
                  onChange={(e) => {
                    setAdhar(e.target.value);
                  }}
                  maxLength={12}
                  placeholder="Enter Adhar Number"
                />
              </div>
            </div>
           
            <div className="row mt-4">
              <div className="col-sm-3">
                <label>
                  Profile Image
                  <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-3">
                <input
                  className="col-sm-12"
                  id="profilePic"
                  type="file"
                  onChange={(e) => {
                    onChangeProfileImage(e);
                  }}
                />

                {profileImage && (
                  <div
                    style={{
                      marginTop: "5px",
                      width: 180,
                      height: 100,
                      aspectRatio: 1 * 1.4,
                    }}
                    className="col-sm-8"
                  >
                    <img
                      alt=""
                      className="playerProfilePic_home_tile"
                      style={{
                        resizeMode: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      src={profileImage}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-3">
                <label>
                  Adhar Card (front)
                  <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-3">
                <input
                  className="col-sm-12"
                  id="profilePic"
                  type="file"
                  onChange={(e) => {
                    onChangePicture(e, "front");
                  }}
                />

                {adharFront && (
                  <div
                    style={{
                      marginTop: "5px",
                      width: 180,
                      height: 100,
                      aspectRatio: 1 * 1.4,
                    }}
                    className="col-sm-8"
                  >
                    <img
                      alt=""
                      className="playerProfilePic_home_tile"
                      style={{
                        resizeMode: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      src={adharFront}
                    />
                  </div>
                )}
              </div>
              <div className="col-sm-3">
                <label className="col-form-label" htmlFor="val-range">
                  Adhar Card (back)
                  <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-3">
                <input
                  className="col-sm-12"
                  id="profilePic"
                  type="file"
                  onChange={(e) => {
                    onChangePicture(e, "back");
                  }}
                />

                {adharBack && (
                  <div
                    style={{
                      marginTop: "5px",
                      width: 180,
                      height: 100,
                      aspectRatio: 1 * 1.4,
                    }}
                    className="col-sm-8"
                  >
                    <img
                      alt=""
                      style={{
                        resizeMode: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      className="playerProfilePic_home_tile"
                      src={adharBack}
                    />
                  </div>
                )}
              </div>
            </div>
            <>
              <div className="row mt-4">
                <div className="col-sm-3">
                  <label className="col-form-label" htmlFor="val-range">
                    Vehicle Category
                    <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-sm-3">
                  <select
                    multiple={false}
                    className="form-control"
                    id="val-skill"
                    name="val-skill"
                    value={RiderVehicleCategory}
                    onChange={(event) => {
                      setRiderVehicleCategory(event.target.value);
                    }}
                  >
                    <option selected={true} disabled="disabled">
                      {RiderVehicleCategory}
                    </option>
                    <option value="bike">Bike</option>
                  </select>
                </div>
               
              </div>
             
              {RiderVehicleCategory === "bike" && (
                <>
                  <div className="row mt-4">
                    <div className="col-sm-3">
                      <label className="col-form-label" htmlFor="val-range">
                        Transport Category
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-sm-3">
                      <select
                        required
                        multiple={false}
                        className="form-control"
                        id="val-skill"
                        name="val-skill"
                        value={transportCategory}
                        onChange={(event) => {
                          setTransportCategory(event.target.value);
                        }}
                      >
                        <option selected={true} disabled="disabled"></option>
                        <option value="own">White Board Bike Transport</option>
                        <option value="rent">Electric Bike Transport</option>
                      </select>
                    </div>
                  </div>
                  <div className="row mt-4">
                    {transportCategory && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Driving Licence (front)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageBike(e, "front");
                            }}
                          />

                          {DlFrontBike && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={DlFrontBike}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    {DlFrontBike && (
                      <>
                        <div className="col-sm-3">
                          <label className="col-form-label" htmlFor="val-range">
                            Driving Licence (Back)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageBike(e, "back");
                            }}
                          />

                          {DlBackBike && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                className="playerProfilePic_home_tile"
                                src={DlBackBike}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
              
            </>
            {spinnerAccept?(<div className="text-center mt-4">
                <Spinner animation="border" variant="primary" />
              </div>):(
                <>
                {(RiderVehicleCategory === "Cycle" ||
              DlBackBike
           ) && (
              <div className="text-center mt-4">
                <input
                  className="btn btn-primary"
                  type="submit"
                  value="submit"
                />
              </div>
            )}
                </>
              )}
            
          </form>
        )}
        <>
          {stepTwo && (
            <form onSubmit={onSendOtp}>
              <div className="form-group"></div>
              <div className="form-group ml-3">
                <OTPInput
                  inputStyles={{
                    width: "50%",
                    height: 68,
                    color: "#135334",
                  }}
                  value={OTP}
                  onChange={setOTP}
                  autoFocus
                  OTPLength={4}
                  otpType="number"
                  disabled={false}
                />
                {errors.otp && (
                  <div className="text-danger fs-12 text-center mt-3">
                    {errors.otp}
                  </div>
                )}
              </div>
              {spinnerVerify?(<div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>):(
                 <div className="text-center">
                 <button type="submit" className="btn btn-primary">
                   Verify
                 </button>
               </div>
              )}
            
            </form>
          )}
        </>
      </Card.Body>
    </Card>
  );
}
